/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UpdateScheduleTransferStatusRequest = {
    properties: {
        status: {
    type: 'ScheduleTransferStatus',
    isRequired: true,
},
    },
};